const Choose = require('./Choose');
const Buy = require('./Buy');
const Collect = require('./Collect');

module.exports = {
  choose: Choose,
  buy: Buy,
  collect: Collect,
};
